import React from 'react';
import { GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid-pro';
import {
	Button,
	IconButton,
	Stack,
	Tooltip,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { RiDownload2Line } from 'react-icons/ri';
import { useTranslation } from 'services/localization';
import { exportAccountingTable } from '../export';

interface Props {
	tableName?: string;
	exportHeaders?: string[];
	exportFileName?: string;
}

const AccountingToolbar = (props: Props) => {
	const { t } = useTranslation();
	const apiRef = useGridApiContext();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	const renderExportButton = () => {
		const label = t('dataGrid.toolbarExport');
		const onClick = () =>
			exportAccountingTable({
				apiRef,
				exportHeaders: props.exportHeaders ?? [],
				options: {
					utf8WithBom: true,
					fileName: props.exportFileName ?? 'accounting_export',
					delimiter: ';',
				},
			});

		return isMobile ? (
			<Tooltip title={label}>
				<IconButton onClick={onClick}>
					<RiDownload2Line size={20} />
				</IconButton>
			</Tooltip>
		) : (
			<Button
				onClick={onClick}
				color="secondary"
				variant="text"
				startIcon={<RiDownload2Line size={20} />}
			>
				{label}
			</Button>
		);
	};

	return (
		<GridToolbarContainer>
			<Stack direction="row" justifyContent="flex-between" alignItems="center" flex="1">
				{!!props.tableName && <Typography variant="body1">{props.tableName}</Typography>}
			</Stack>
			<Stack direction="row" justifyContent="flex-end" alignItems="center" flex="1">
				{renderExportButton()}
			</Stack>
		</GridToolbarContainer>
	);
};

export default AccountingToolbar;
